export const messageConstants = {
  MESSAGE_HAS_ERRORED: 'MESSAGE_HAS_ERRORED',
  MESSAGE_IS_LOADING: 'MESSAGE_IS_LOADING',
  MESSAGE_FETCH_DATA_SUCCESS: 'MESSAGE_FETCH_DATA_SUCCESS',
  MESSAGE_DEL_ONE_SUCCESS: 'MESSAGE_DEL_ONE_SUCCESS',
  MESSAGE_GET_ONE_SUCCESS: 'MESSAGE_GET_ONE_SUCCESS',
  MESSAGE_GET_ALL_SUCCESS: 'MESSAGE_GET_ALL_SUCCESS',
  MESSAGE_ADD: 'MESSAGE_ADD',
};
